import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import Section from './Section';

// Newest first. Keep each item to one line.
const news = [
  {
    date: 'Oct 2026',
    text: 'Attended the Bay Area Robotics Symposium (BARS) at UC Berkeley.',
  },
  {
    date: 'Sep 2026',
    text: <>Joined the <Link href="https://sisl.stanford.edu/" target="_blank" rel="noopener noreferrer">Stanford Intelligent Systems Laboratory</Link> to work on robot failure detection.</>,
  },
  {
    date: 'Jun 2026',
    text: 'Started an internship at Google Search Intelligence, working on position-bias correction in retrieval.',
  },
  {
    date: 'Jan 2026',
    text: <>Presented a poster on <Link href="https://arxiv.org/abs/2511.06456" target="_blank" rel="noopener noreferrer">EIDSeg</Link> at AAAI 2026 in Singapore.</>,
  },
  {
    date: 'Sep 2025',
    text: <>Joined the <Link href="https://www.gsb.stanford.edu/faculty-research/labs-initiatives/sil" target="_blank" rel="noopener noreferrer">Golub Capital Social Impact Lab</Link> to work on recommendation systems and personalization.</>,
  },
];

const News = () => {
  return (
    <Section id="news" title="News">
      <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
        {news.map((item, index) => (
          <Box component="li" key={index} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0, sm: 2 }, mb: { xs: 2, sm: 1.25 } }}>
            <Typography sx={{ color: 'text.secondary', fontSize: { xs: '0.85rem', sm: '1rem' }, width: { sm: 90 }, flexShrink: 0, fontVariantNumeric: 'tabular-nums' }}>
              {item.date}
            </Typography>
            <Typography>{item.text}</Typography>
          </Box>
        ))}
      </Box>
    </Section>
  );
};

export default News;
